<ng-container>
  <div
    class="anchor"
    ftrPopover
    [popoverContent]="content"
    popoverArrowNavigation="vertical"
    popoverRole="menu"
    [popoverAllowAnchorDetach]="false"
    (popoverOpenChanged)="handleOpenChanged($event)"
  >
    <ng-content />
  </div>

  <ng-template #content>
    <ftr-remote
      [remote]="(menuItemsApiResult() | async) ?? NotAsked"
      [successTemplate]="success"
      [failureTemplate]="error"
      [loadingTemplate]="loading"
    />
  </ng-template>
</ng-container>

<ng-template #success let-data [ftrTypedContext]="menuItemsApiResult()">
  <ftr-menu
    [menuItems]="data"
    [maxWidth]="maxWidth()"
    [minWidth]="minWidth()"
    [itemsBeforeScroll]="itemsBeforeScroll()"
    (itemClicked)="popover().closeOverlay()"
    [attr.data-track-group]="menuTrackGroup()"
    [trackClicks]="!!menuTrackGroup()"
  />
</ng-template>

<ng-template #error>
  <ftr-error-state
    class="dropdown-state"
    [style.width]="maxWidthRem()"
    type="card-medium"
    [errorMessage]="errorMessage()"
  />
</ng-template>
<ng-template #loading>
  <ftr-loader
    class="dropdown-state"
    [style.width]="maxWidthRem()"
    [size]="loaderSize"
    [isLoading]="true"
    [iconOnly]="true"
  />
</ng-template>
